import { DownloadOutlined } from '@ant-design/icons';
import { GetFrontRichiesteIdImmaginiIdDimensioni } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { FlexRow, LoaderSpin, ModalDialog } from '@framework/ui';
import { Button } from 'antd';
import { linkFileToDownload } from '../../../../utils/download/linkFileToDownload';
import { usePreviewSubmissionImageAttachment } from './usePreviewSubmissionImageAttachment';

export interface IPreviewSubmissionImageAttachmentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  submissionId: string;
  attachmentId: string;
  dimension?: GetFrontRichiesteIdImmaginiIdDimensioni;
}

/**
 * Componente per la visualizzazione di un'anteprima di un'immagine allegata
 */
export function PreviewSubmissionImageAttachmentModal(
  props: IPreviewSubmissionImageAttachmentModalProps,
) {
  const { open, setOpen, submissionId, attachmentId, dimension } = props;
  const { t } = useTranslation();

  const { imageInfo, isLoading } = usePreviewSubmissionImageAttachment({
    submissionId,
    attachmentId,
    dimension: dimension ?? GetFrontRichiesteIdImmaginiIdDimensioni.ORIGINALE,
    enabled: open,
  });

  return (
    <ModalDialog
      open={open}
      title={t('widget-immagine.anteprima', 'Anteprima Immagine')}
      style={{ maxWidth: '90vw', maxHeight: '90vh' }}
      centered
      destroyOnClose
      okButtonProps={{ style: { display: 'none' } }}
      onCancel={() => setOpen(false)}
      footer={(_, extra) => {
        return (
          <FlexRow
            left={
              <Button
                size="middle"
                type="default"
                loading={isLoading}
                disabled={!imageInfo || isLoading}
                onClick={() => {
                  if (!imageInfo) return;

                  linkFileToDownload({
                    fileBlobUrl: imageInfo.url,
                    filename: imageInfo.fileName,
                    mimetype: imageInfo.mimeType,
                  });
                }}
                icon={<DownloadOutlined aria-hidden={true} />}
              >
                {t('widget-immagine.scarica', 'Scarica Immagine')}
              </Button>
            }
          >
            <Button type="default" onClick={() => setOpen(false)}>
              {t('widget-immagine.chiudi', 'Chiudi')}
            </Button>
          </FlexRow>
        );
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {isLoading && <LoaderSpin full />}
        {!isLoading && imageInfo && (
          <img
            src={imageInfo?.url}
            alt="Preview"
            style={{
              width: 'auto',
              height: 'auto',
              maxWidth: '100%',
              maxHeight: 'calc(80vh - 120px)',
              alignItems: 'center',
            }}
          />
        )}
      </div>
    </ModalDialog>
  );
}
